/* assets/aa-narrative-ss26.js
   - Imagen clickable → va al producto activo
   - Desktop: solo flecha derecha (next)
   - Mobile: swipe + dots + hint
   - Rotación automática + reveal card
   ✅ FIX: swipe funciona aunque exista el link overlay (producto)
*/
(function () {
  function parseProductsJson(sectionId) {
    var el = document.querySelector('script[type="application/json"][data-aa-products-json="' + sectionId + '"]');
    if (!el) return {};
    try { return JSON.parse(el.textContent || "{}"); } catch (e) { return {}; }
  }

  function isMobile() {
    return window.matchMedia && window.matchMedia("(max-width: 1024px)").matches;
  }

  function hexToRgba(hex, opacityPercent) {
    if (!hex) hex = "#ffffff";
    hex = (hex + "").replace("#", "").trim();
    if (hex.length === 3) hex = hex.split("").map(function (c) { return c + c; }).join("");
    if (hex.length !== 6) hex = "ffffff";
    var r = parseInt(hex.substring(0, 2), 16);
    var g = parseInt(hex.substring(2, 4), 16);
    var b = parseInt(hex.substring(4, 6), 16);
    var a = Math.max(0, Math.min(1, (opacityPercent || 88) / 100));
    return "rgba(" + r + "," + g + "," + b + "," + a + ")";
  }

  function initSection(root) {
    if (!root) return;

    if (root.__aaTimer) {
      clearInterval(root.__aaTimer);
      root.__aaTimer = null;
    }
    if (root.__aaMobileTimers) {
      root.__aaMobileTimers.forEach(function (t) { clearTimeout(t); });
    }
    root.__aaMobileTimers = [];

    var sectionId = root.getAttribute("data-aa-section-id");
    var intervalMs = parseInt(root.getAttribute("data-aa-rotation"), 10) || 5000;

    var mobileDelayMs = parseInt(root.getAttribute("data-aa-mobile-delay"), 10);
    if (isNaN(mobileDelayMs)) mobileDelayMs = 1000;

    var mobileCardBg = root.getAttribute("data-aa-mobile-card-bg") || "#F7F3EE";
    var mobileCardOpacity = parseInt(root.getAttribute("data-aa-mobile-card-opacity"), 10);
    if (isNaN(mobileCardOpacity)) mobileCardOpacity = 88;

    var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduceMotion) intervalMs = 0;

    var products = parseProductsJson(sectionId);
    var cols = root.querySelectorAll("[data-aa-col]");
    if (!cols.length) return;

    function getItems(col) {
      var rotator = col.querySelector("[data-aa-rotator]");
      if (!rotator) return [];
      return Array.prototype.slice.call(rotator.querySelectorAll(".aa-rotator-item"));
    }

    function getActiveIndex(items) {
      for (var i = 0; i < items.length; i++) {
        if (items[i].classList.contains("is-active")) return i;
      }
      return 0;
    }

    function setActiveByIndex(items, nextIdx) {
      if (!items.length) return;
      var cur = getActiveIndex(items);
      items[cur].classList.remove("is-active");
      items[nextIdx].classList.add("is-active");
    }

    function rotateCol(col, dir) {
      if (!dir) dir = 1;
      var items = getItems(col);
      if (items.length <= 1) return;
      var idx = getActiveIndex(items);
      var next = (idx + dir) % items.length;
      if (next < 0) next = items.length - 1;
      setActiveByIndex(items, next);
    }

    function setImageLink(col, p) {
      var link = col.querySelector("[data-aa-col-link]");
      if (!link) return;
      if (p && p.url) {
        link.setAttribute("href", p.url);
        link.style.pointerEvents = "auto";
      } else {
        link.setAttribute("href", "#");
        link.style.pointerEvents = "none";
      }
    }

    function fillCard(col, p) {
      var card = col.querySelector("[data-aa-card]");
      if (!card) return;

      if (!p) {
        card.classList.remove("is-visible");
        card.setAttribute("href", "#");
        return;
      }

      var img = card.querySelector("[data-aa-img]");
      var title = card.querySelector("[data-aa-title]");
      var price = card.querySelector("[data-aa-price]");

      if (img) { img.src = p.img; img.alt = p.title || ""; }
      if (title) title.textContent = p.title || "";
      if (price) price.textContent = p.price || "";

      if (p.url) card.setAttribute("href", p.url);

      if (isMobile()) card.style.background = hexToRgba(mobileCardBg, mobileCardOpacity);
      else card.style.background = "rgba(255,255,255,0.86)";

      card.classList.add("is-visible");
    }

    function getActiveProduct(col) {
      var active = col.querySelector(".aa-rotator-item.is-active");
      var handle = active ? (active.getAttribute("data-product-handle") || "") : "";
      return handle && products[handle] ? products[handle] : null;
    }

    function ensureDots(col) {
      var dotsWrap = col.querySelector("[data-aa-dots]");
      if (!dotsWrap) return;

      var items = getItems(col);
      dotsWrap.innerHTML = "";

      if (items.length <= 1) {
        dotsWrap.style.display = "none";
        var hint = col.querySelector("[data-aa-swipe-hint]");
        if (hint) hint.style.display = "none";
        return;
      }

      for (var i = 0; i < items.length; i++) {
        var d = document.createElement("span");
        d.className = "aa-dot" + (i === 0 ? " is-active" : "");
        d.setAttribute("data-aa-dot", String(i));
        dotsWrap.appendChild(d);
      }
    }

    function updateDots(col) {
      var dotsWrap = col.querySelector("[data-aa-dots]");
      if (!dotsWrap) return;

      var dots = dotsWrap.querySelectorAll(".aa-dot");
      if (!dots.length) return;

      var items = getItems(col);
      var idx = getActiveIndex(items);

      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle("is-active", i === idx);
      }
    }

    function updateColUI(col) {
      var p = getActiveProduct(col);
      fillCard(col, p);
      setImageLink(col, p);
      updateDots(col);
      return !!p;
    }

    function armMobileReveal(col, hasProduct) {
      if (!isMobile()) {
        col.classList.remove("is-revealed");
        return;
      }

      col.classList.remove("is-revealed");

      if (hasProduct) {
        var t = setTimeout(function () {
          col.classList.add("is-revealed");
        }, Math.max(0, mobileDelayMs));
        root.__aaMobileTimers.push(t);
      }
    }

    function bindNext(col) {
      if (col.__aaNextBound) return;
      col.__aaNextBound = true;

      var next = col.querySelector("[data-aa-next]");
      if (!next) return;

      next.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        rotateCol(col, +1);
        var has = updateColUI(col);
        if (isMobile()) armMobileReveal(col, has);
      });
    }

    // ✅ FIX REAL: bind swipe en el CONTENEDOR col (captura)
    function bindSwipe(col) {
      if (col.__aaSwipeBound) return;
      col.__aaSwipeBound = true;

      var x0 = null, y0 = null, t0 = 0;
      var locked = null; // 'h' | 'v'
      var moved = false;
      var THRESH = 10;

      col.addEventListener("touchstart", function (e) {
        if (!e.touches || !e.touches[0]) return;
        x0 = e.touches[0].clientX;
        y0 = e.touches[0].clientY;
        t0 = Date.now();
        locked = null;
        moved = false;
      }, { passive: true, capture: true });

      col.addEventListener("touchmove", function (e) {
        if (x0 === null || y0 === null) return;
        if (!e.touches || !e.touches[0]) return;

        var x = e.touches[0].clientX;
        var y = e.touches[0].clientY;
        var dx = x - x0;
        var dy = y - y0;

        if (!locked) {
          if (Math.abs(dx) > THRESH || Math.abs(dy) > THRESH) {
            locked = (Math.abs(dx) > Math.abs(dy)) ? "h" : "v";
          }
        }

        if (locked === "h") {
          moved = true;
          e.preventDefault(); // evita que el navegador lo trate como scroll vertical
        }
      }, { passive: false, capture: true });

      col.addEventListener("touchend", function (e) {
        if (x0 === null || y0 === null) return;

        var touch = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0] : null;
        if (!touch) { x0 = y0 = null; return; }

        var dx = touch.clientX - x0;
        var dy = touch.clientY - y0;
        var dt = Date.now() - t0;

        x0 = y0 = null;

        var absX = Math.abs(dx);
        var absY = Math.abs(dy);

        // solo gesto horizontal claro
        if (absX < 45) return;
        if (absY > absX * 0.7) return;
        if (dt > 900) return;

        if (dx < 0) rotateCol(col, +1);
        else rotateCol(col, -1);

        var has = updateColUI(col);
        armMobileReveal(col, has);
      }, { passive: true, capture: true });

      // ✅ si hubo swipe, cancelamos click (para que no navegue al producto)
      col.addEventListener("click", function (e) {
        if (!moved) return;
        var link = e.target && e.target.closest ? e.target.closest("[data-aa-col-link]") : null;
        if (link) {
          e.preventDefault();
          e.stopPropagation();
        }
        moved = false;
      }, true);
    }

    // Init
    cols.forEach(function (col) {
      ensureDots(col);
      bindNext(col);
      bindSwipe(col);

      var hasProduct = updateColUI(col);
      armMobileReveal(col, hasProduct);
    });

    // Auto-rotation
    if (intervalMs > 0) {
      root.__aaTimer = setInterval(function () {
        cols.forEach(function (col) {
          rotateCol(col, +1);
          var has = updateColUI(col);
          if (isMobile()) armMobileReveal(col, has);
        });
      }, intervalMs);
    }
  }

  function initAll() {
    document.querySelectorAll(".aa-narrative[data-aa-section-id]").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);
  document.addEventListener("shopify:section:reorder", initAll);
  document.addEventListener("shopify:block:select", initAll);

  window.addEventListener("resize", function () {
    clearTimeout(window.__aaResizeT);
    window.__aaResizeT = setTimeout(initAll, 220);
  });
})();
